<template>
  <router-view />
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.8);
}

* {
  box-sizing: border-box;
}
html,
body {
  padding: 0;
  margin: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

:root {
  --tab-group-second-font-size: 12px; /*列表单元格两行内容的第二行字体大小*/
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}

.list-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  display: flex;
  flex-direction: column;

  & > .list-search {
    display: flex;
    border: 1px solid var(--el-border-color-lighter);
    padding: 10px;
    border-bottom: 0;
  }

  & > .list-table {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }
}

.tabCss {
  border-left: 1px solid var(--el-table-border-color) !important;
  border-top: 1px solid var(--el-table-border-color) !important;
  border-right: 1px solid var(--el-table-border-color) !important;
}

.text-hover-decoration {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

/*扣缴义务人和供应商角标 */
.withholding-badge {
  text-indent: 20px;
  position: relative;

  &::before {
    content: attr(data-type);
    text-indent: 0;
    top: 3px;
    color: #fff;
    font-size: 11px;
    padding: 2px;
    line-height: 12px;
    background-color: var(--dynamic-color) !important;
    position: absolute;
    border-radius: 2px;
    left: 0;
  }
}

.detail-tab {
  width: 100%;
  & tr > td:nth-child(2n + 1) {
    text-align: right;
    color: #a2a2a2;
  }
}
</style>
